import messages from '@super-template/messages';
import {FormattedMessage, useIntl} from 'react-intl';
import Page from '../../layouts/Page';
import {Backdrop, Box, Button, FormControlLabel, FormLabel, Radio, RadioGroup, Typography} from "@material-ui/core";
import FormFieldControl from "@super-template/core/src/formFields/FormFieldControl";
import useSessionStorage from '@postinumero/storage/useSessionStorage';
import {useContext, useState} from 'react';
import {generatePath, useHistory, useParams} from "react-router-dom";
import {path as calendar} from "../calendar";
import {SettingsContext} from "../application/utils";
import {saveWishArray} from "../utils";
import {makeStyles} from "@material-ui/core/styles";

export const path = '/:organization/welcome';
export const exact = true;

const useStyles = makeStyles(() => ({
  root: {
    margin: '50px auto',
    background: 'white',
    maxWidth: '500px',
    borderRadius: 4,
    padding: 25
  },
  header: {
    paddingBottom: 25
  },
  button: {
    marginLeft: 'auto'
  }
}));

export const component = function Welcome() {
  const {organization} = useParams();
  const history = useHistory();
  const intl = useIntl();
  const classes = useStyles();
  const [familyHoliday, setFamilyHoliday] = useSessionStorage('familyHoliday');
  const {organization: {isHolidayOrganization: holiday}} = useContext(SettingsContext);
  const [radio, setRadio] = useState(familyHoliday);

  const redirect = () => {
    if (radio) {
      if (radio !== familyHoliday) {
        setFamilyHoliday(radio);
        saveWishArray([]);
      }
      history.push(generatePath(calendar, {organization}));
    }
  };

  return (
    <Page title={<FormattedMessage {...holiday ? messages.holiday_search : messages.course_search} />}>
      <Backdrop open/>
      <Box display="flex" flexDirection="column" className={classes.root}>
        <Typography component={"h2"} variant={"h6"} className={classes.header}>
          <FormattedMessage {...holiday ? messages.holiday_type : messages.course_type} />
        </Typography>
        <Typography variant={"subtitle1"} paragraph>
          <FormattedMessage {...holiday ? messages.holidaytype_description : messages.coursetype_description} />
        </Typography>
        <FormFieldControl component="fieldset">
          <FormLabel component="legend"><FormattedMessage {...messages.choose} /></FormLabel>
          <RadioGroup aria-label={intl.formatMessage(holiday ? messages.holiday_type : messages.course_type)}
                      name={'holidayType'} value={radio} onChange={(e) => setRadio(e.target.value)}>
            <FormControlLabel
              key={'false'} value={'false'} control={<Radio/>}
              label={<FormattedMessage {...holiday ? messages.adult_holidays : messages.adult_courses} />}/>
            <FormControlLabel
              key={'true'} value={'true'} control={<Radio/>}
              label={<FormattedMessage {...holiday ? messages.family_holidays : messages.family_courses} />}/>
          </RadioGroup>
        </FormFieldControl>
        <Button variant="contained" color="primary" className={classes.button} onClick={redirect}>
          <FormattedMessage {...messages.continue} />
        </Button>
      </Box>
    </Page>
  );
};
